exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-view-table {\n  table-layout: fixed;\n}\n.user-view-table td {\n  padding-right: 0;\n  padding-left: 0;\n  border: 0;\n}\n.user-view-table td:first-child {\n  width: 9rem;\n}\n.user-view-table td:not(:first-child) {\n  min-width: 12rem;\n}\n.user-edit-fileinput {\n  position: absolute;\n  visibility: hidden;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n}\n.user-edit-multiselect ~ .select2-container {\n  width: 100% !important;\n}", ""]);

// exports
